import { duplicatesLimitCount } from 'reactApp/appHelpers/featuresHelpers/features/duplicates';
import { removeDuplicateFromContextMenuStart } from 'reactApp/modules/duplicates/duplicates.actions';
import { getDuplicatesRemovedGroupsCount } from 'reactApp/modules/duplicates/duplicates.flags';
import type { IDuplicateItem } from 'reactApp/modules/duplicates/duplicates.types';
import { removeRequest } from 'reactApp/modules/modifying/modifying.actions';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getItemById } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store as reduxStore } from 'reactApp/store';
import { renderDuplicatesRemoveLimitModal } from 'reactApp/ui/Duplicates/DuplicatesRemoveLimitModal/DuplicatesRemoveLimitModal.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { getSelectedItemsOrCurrentFolder } from './helpers/getSelectedItemsOrCurrentFolder';

export const remove = (id?: string, sendAnalytics?: (data?: any) => void, place?: any): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const items = getSelectedItemsOrCurrentFolder();
    const item = id && getItemById(state, id);

    if (currentStorage === EStorageType.vigbo) {
        sendPaymentGa({
            eventCategory: ECategoryGa.vigbo,
            action: 'move-to-trash',
            place: place === 'toolbar' || place === 'context-menu' ? place : undefined,
        });
    }

    if (currentStorage === EStorageType.duplicates && items.length > 0) {
        const isCorp = UserSelectors.isCorpUser(state);
        const isPaid = UserSelectors.isPaidUser(state);
        const duplicatesLimitEnabled = !isCorp && !isPaid;

        getDuplicatesRemovedGroupsCount().then((removedGroupsCount) => {
            if (duplicatesLimitEnabled && removedGroupsCount >= duplicatesLimitCount) {
                // Лимит исчерпан
                renderDuplicatesRemoveLimitModal();
            } else {
                reduxStore.dispatch(removeDuplicateFromContextMenuStart({ item: items[0] as IDuplicateItem }));
            }
        });

        return;
    }

    const onSuccess = () => {
        sendAnalytics?.({
            action: 'delete',
            source: currentStorage,
            count_files: items.length,
            items,
        });
    };

    reduxStore.dispatch(removeRequest({ items: item ? [item] : items, withRemoveDialog: true, onSuccess }));
};
